import { ReportDto, UserProfileDto, UserRole } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_REPORTS } from "../domain";

import { reportsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_GET_REPORT = "GET_REPORT";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const getReport = async (
  reportId: string,
  additionalDatasetId: string,
  clientId: string,
): Promise<ReportDto> => {
  const response = await reportsApi.reportsControllerGetReport(
    reportId,
    additionalDatasetId,
    clientId,
  );

  return response.data;
};

export const useGetReport = (
  user: UserProfileDto | null,
  reportId: string,
  additionalDatasetId: string,
  clientId: string,
): {
  report: ReportDto | undefined;
  refetchGetReport: () => void;
  isLoadinGetReport: boolean;
  isFetchingGetReport: boolean;
  isSuccessGetReport: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryResult = useQuery<ReportDto, Error>({
    queryKey: [
      DOMAIN_REPORTS,
      ACTION_GET_REPORT,
      { reportId, additionalDatasetId, clientId },
    ],
    queryFn: () => getReport(reportId, additionalDatasetId, clientId),
    enabled,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    structuralSharing: false,
    retry: 0,
  });

  return {
    report: queryResult.data,
    refetchGetReport: queryResult.refetch,
    isLoadinGetReport: queryResult.isLoading,
    isFetchingGetReport: queryResult.isFetching,
    isSuccessGetReport: queryResult.isSuccess,
  };
};
